
import wx from "weixin-js-sdk";

/**
 * 微信分享
 * @param {*} config 
 * @param {*} share 
 */
export const jssdk_share = (config, share) => {

    if (!process.env.WECHAT_SHARE) {
        return;
    }

    wx.config({
        debug: config.debug,
        appId: config.appId,
        timestamp: parseInt(config.timestamp),
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: config.jsApiList
    });

    var data = {
        title: share.title,         // 分享标题
        desc: share.desc,           // 分享说明
        link: window.location.href, // 分享链接
        imgUrl: share.imgUrl,       // 分享图标
        success: function () {
            // alert("成功");
        },
        cancel: function () {
            // alert("失败")
        }
    }

    wx.ready(function () {
        wx.onMenuShareAppMessage(data);
        wx.onMenuShareTimeline(data);
    });
}